'use client';

import { Button } from '@/components/ui/Button';
import type { ButtonVariant } from '@/components/ui/Button';

type Props = {
  submitting: boolean;
  disabled: boolean;
  idleLabel: string;
  submittingLabel: string;
  variant?: ButtonVariant;
};

export function SubmitButton({
  submitting,
  disabled,
  idleLabel,
  submittingLabel,
  variant = 'cta',
}: Props) {
  return (
    <Button
      type="submit"
      variant={variant}
      isLoading={submitting}
      disabled={disabled}
      className="flex-1 py-3.5"
    >
      {submitting ? submittingLabel : idleLabel}
    </Button>
  );
}
